module.exports = __webpack_public_path__ + "img/shopping-trolley.a43207be.svg";